import { useContext } from 'react';

import { ApiServiceContext } from '../context/ApiServiceContext';

export default function useApiService() {
  const context = useContext(ApiServiceContext);

  if (!context) {
    throw new Error('Could not use ApiServiceContext, hook might have been used outside of ApiServiceProvider');
  }

  return context;
}
